import { DependencyList, useRef } from 'react';

export default function useInitializer<T>(buildInitialValue: () => T, deps?: DependencyList): T {
	const valRef = useRef<T | null>(null);
	const depsRef = useRef<DependencyList | undefined>();

	const depsChanged =
		deps === undefined ||
		depsRef.current === undefined ||
		deps.length !== depsRef.current.length ||
		!deps.every((dep, index) => dep === depsRef.current![index]);

	if (depsChanged) {
		valRef.current = buildInitialValue();
	}

	depsRef.current = deps;

	return valRef.current as T;
}
